module.exports = __webpack_public_path__ + "img/llamadopaciente.0a5b25eb.gif";